<style lang="scss" scoped>
@import "$vars";
label , span  {
  font-size: 1em;
  strong {
    display: block;
    margin-bottom: 10px !important
  }
  display: block;
  margin-bottom: 20px
}
.card {
  background: #f6f6f6;
  margin-bottom: 1em;
  padding-bottom: 0.8rem
}
.flex-column {
  input, textarea {
    padding: 5px;
    background: transparent
  }
  textarea {
    border-left-width: 0;
    border-right-width: 0;
    border-top-width: 0;
    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      padding-top: 3em;
    }
    &::-moz-placeholder { /* Firefox 19+ */
      padding-top: 3em;
    }
    &:-ms-input-placeholder { /* IE 10+ */
      padding-top: 3em;
    }
    &:-moz-placeholder { /* Firefox 18- */
      padding-top: 3em;
    }
  }
}
.description {
  width: 100%;
  padding-right: 10px
}

.toast-warning {
  background: #fcf8e3;
  color: #94794a;
  border-color: #f5f3e0;
  margin-bottom: 10px;
  p {
    margin: 0
  }
}

h5 {
  color: #4a4a4a;
  font-family: $base-font-family;
  font-size: 18px;
  font-weight: 600;
}

h2 {
  color: #4a4a4a;
}
input, select {
  &.select--model {
    padding-right: 0 !important
  }
  &.--selected {
    padding: 8px 0px;
  }
  &.--quantity {
    padding: 3px
  }
}

.allergies-alert {
  background-color: rgba(250, 173, 20, 0.1);
  border: 1px solid $color-yellow;
  border-radius: 4px;
  box-sizing: border-box;
  margin: 0;
  padding: 10px;

  &__wrapper {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  &__text {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  &__item {
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-size: 0.7rem;
    font-weight: 600;
    margin: 0;
    padding: 0;
  }

  &__description {
    box-sizing: border-box;
    color: #8E8E92;
    font-size: 0.7rem;
    margin: 5px 0 0 10px;
    padding: 0;
  }

  &__caret {
    border: 6px solid transparent;
    border-top: 0;
    border-bottom: 6px solid #8E8E92;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    height: 0;
    margin: 0 5px 0 0;
    padding: 0;
    width: 10px;

    &--down {
      transform: rotate(180deg);
      transition: all ease 0.1s;
    }

    &--right {
      transform: rotate(90deg);
      transition: all ease 0.1s;
    }
  }
}

.files-list {
  width: 100%;
}

.files {
  @apply px-2;
  flex: 0 0 calc((100% - 1rem) / 4);
  margin: 0 0 1.75rem 0;

  &__digital-signature {
    @apply max-w-full rounded-sm text-white cursor-default block font-semibold text-xs my-0 mx-auto;
    background: rgb(6, 100, 191);
    padding: 0.125rem 0.3rem;
    width: max-content;
  }
}

.modal-footer {
  span {
    display: flex;
    width: max-content;
  }
}
.info {
  box-sizing: border-box;
  margin: 0.3rem 0 0.7rem;
  padding: 0.6rem;

    &__text {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-size: 0.75rem;
    }
  }
</style>

<template>
  <main class="component-patients" v-if="loaded">
    <printTemplate
      v-if="modalActive != null"
      :active.sync="modalActive"
      :prescriptionForm="prescriptionForm"
      :patient="patient"
      :copies="getCopies(modalActive)"
      :type="getCopies(modalActive) === 1
        ? 'prescriptionSpecial'
        : 'prescription'
      "
      @cancel="modalActive = null"
    />

    <div class="allergies-alert" v-if="allergies.hasAllergies === true">
      <p class="allergies-alert__text">
        <strong class="allergies-alert__item" @click="toggleCaret('#caret')">
          <span class="allergies-alert__caret allergies-alert__caret--right" id="caret"></span>
           Veja informações alérgicas deste paciente
        </strong>
        <transition-group v-if="allergies.collapsed" name="slide-down" mode="in-out" class="allergies-alert__wrapper">
          <span class="allergies-alert__description" key="allergies_selfEvaluation" v-if="allergies.selfEvaluation">
            <b>Autoavaliação:</b>
            {{ allergies.selfEvaluation }}
          </span>
          <span class="allergies-alert__description" key="allergies_anamnesis" v-if="allergies.anamnesis">
            <b>Anamnese:</b>
            {{ allergies.anamnesis }}
          </span>
        </transition-group>
      </p>
    </div>
    <div class="allergies-alert" v-if="allergies.hasAllergies === false">
      <p class="allergies-alert__text">
        <strong class="allergies-alert__item">
          O paciente ainda não disponibilizou informações sobre alergias.
        </strong>
      </p>
    </div>

    <div class="columns">
      <div class="info">
        <p class="info__text">
          No formulário abaixo você pode prescrever os medicamentos ao seu
          paciente, mas lembre-se que cada remédio de uso controlado gera
          uma receita independente e os demais remédios serão agrupados
          em uma única receita.
        </p>
      </div>

      <label class="column col-7">
        <strong>Modelos de prescrição &emsp; <dr-loader class="d-inline" v-if="loading"></dr-loader></strong>
        <select v-if="!loading" :disabled="!appointmentStarted" class="form-select select--model" v-model="selectedModel">
          <option :value="null">Selecione o modelo</option>
          <option v-for="model of models" :value="model.id" :key="model.id">{{model.name}}</option>
        </select>
      </label>
      <label class="column col-4">
        <strong>Data</strong>
        <div class="has-icon-right">
          <input disabled class="form-input" type="text" :value="Date() | TO_DATE" />
          <dr-icon class="form-icon" fill="blue" name="dashCalendar"></dr-icon>
        </div>
      </label>

      <dr-medical-prescription
        :selectedModel="selectedModel"
        :models="models"
        :resetForm="resetAutocompletes"
        class="column col-12"
        @checked="prescriptionForm.valid = $event === true ? false : true"
        @updated="prescriptionForm.prescriptionMedicaments = $event"
        @newMedicament="newMedicamentFormActive = $event"
        @formValid="prescriptionForm.valid = $event"
      />

      <footer>
        <dr-submit
          :disabled="!prescriptionForm.valid || newMedicamentFormActive === true"
          :sending="sending"
          size="sm"
          text="Salvar"
          @click="submit()"
        />
      </footer>
    </div>

    <file-history
      v-if="isActiveAppointment"
      type="prescription"
      :appointment-id="appointment.id"
      :is-active-appointment="isActiveAppointment"
      :is-medical-history-visible="isMedicalHistoryVisible.status"
      :appointment-date="appointment['appointment_start']"
    />
  </main>
</template>

<script>
import drMedicalPrescription from '@/components/form/medicalPrescription'
import drSubmit from '@/components/form/submit'
import printTemplate from '@/components/templates/print/'
import FileHistory from '@/components/layout/appointments/fileHistory'
import EventBus from '@/globals/eventBus'

export default {
  props: {
    patient: {
      required: false
    },

    appointment: {
      required: false
    },

    appointmentStarted: {
      required: false
    },

    isMedicalHistoryVisible: {
      required: false
    },

    isHistory: {
      default: () => false
    }
  },

  components: {
    drMedicalPrescription,
    drSubmit,
    printTemplate,
    FileHistory
  },

  data () {
    return {
      allergies: {
        collapsed: false,
        hasAllergies: null,
        selfEvaluation: null,
        anamnesis: null
      },
      details: '',
      loaded: false,
      loading: true,
      sending: false,
      prescriptionId: null,
      prescriptions: [],
      modalActive: null,
      models: [],
      selectedModel: null,
      print: null,
      resetAutocompletes: null,
      newMedicamentFormActive: false,
      prescriptionForm: {
        valid: false,
        id: null,
        agenda: this.appointment.id,
        name: '',
        prescriptionMedicaments: []
      },
      currentDocument: null,
      modalType: null
    }
  },

  computed: {
    appointmentPrescriptions () {
      const todayPrescriptions = []
      const currentAppointment = this.$store.getters.getActiveAppointments
      this.prescriptions.forEach((prescription) => {
        currentAppointment.forEach((appointment) => {
          if (appointment.id === prescription.agenda.id) {
            todayPrescriptions.push(prescription)
          }
        })
      })
      return todayPrescriptions
    },

    appointmentId () {
      return this.$attrs.agenda_id
    },

    isActiveAppointment () {
      if (
        this.$store.getters.getActiveAppointments.length > 0 &&
        this.$store.getters.getActiveAppointments[0].id === this.appointmentId
      ) {
        return true
      }

      return false
    }
  },

  created () {
    EventBus.$on('submit-medicalPrescription', (args) => {
      if (!(!this.prescriptionForm.valid || this.newMedicamentFormActive)) {
        this.submit(args)
        return
      }

      this.$store.dispatch('setModalAlert', {
        title: 'Atenção',
        body: 'Este formulário contém dados inválidos e não foi possível salvá-lo.',
        size: 'md',
        active: true
      })
    })
  },

  mounted () {
    this.fetchPrescriptions()
    this.fetchModels()

    const anamnesisAllergies = this.getAnamnesisAllergies()
      .then((res) => {
        this.allergies.anamnesis = res
      })
      .catch((err) => {
        console.log('anamnesisResponse \n', err)
        this.allergies.anamnesis = null
      })

    const selfEvaluationAllergies = this.getSelfEvaluationAllergies()
      .then((res) => {
        this.allergies.selfEvaluation = res
      })
      .catch((err) => {
        console.log('selfEvaluationResponse \n', err)
        this.allergies.selfEvaluation = null
      })

    Promise.all([anamnesisAllergies, selfEvaluationAllergies])
      .finally(() => {
        if (this.allergies.anamnesis || this.allergies.selfEvaluation) {
          this.allergies.hasAllergies = true
        } else {
          this.allergies.hasAllergies = false
        }
      })
  },

  methods: {
    isToday (prescription) {
      return this.$moment().isSame(this.$moment(prescription['created_at']), 'day')
    },

    async getAnamnesisAllergies () {
      const agendaResponse = await this.$http.get(`/doctor/agenda?filterAnd[a.id]=${this.appointmentId}`, this.$store.getters.getAuthHeader)
      const anamnesisId = agendaResponse.data.data[0].anamnesisId
      const anamnesisResponse = await this.$http.get(`/anamnesis/${anamnesisId}`, this.$store.getters.getAuthHeader)
      return anamnesisResponse.data.allergies
    },
    async getSelfEvaluationAllergies () {
      const selfEvaluationResponse = await this.$http.get(`/doctor/patient/${this.patient.id}/self_evaluation`, this.$store.getters.getAuthHeader)
      return selfEvaluationResponse.data.allergies
    },
    hasMedicament () {
      return this.medicament.name && this.medicament.quantity && this.medicament.posology
    },
    fetchModels () {
      this.fn_SHOW_PROGRESS()
      this.$http.get('/doctor/prescription_model?itensPerPage=50', this.$store.getters.getAuthHeader).then(
        (res) => {
          this.models = res.data.data
          this.loading = false
        }
      ).catch(
        (err) => {
          console.log(err)
        }
      ).finally(() => {
        this.fn_HIDE_PROGRESS()
      })
    },
    fetchPrescriptions () {
      this.fn_SHOW_PROGRESS()
      this.$http.get(`/prescription?order[p.createdAt]=desc&filterAnd[${this.$route.params.patientType === 'patient' ? 'u' : 'sp'}.id]=${this.patient.id}`, this.$store.getters.getAuthHeader).then(
        (res) => {
          this.loaded = true
          this.prescriptions = res.data.data
          for (let obj of this.prescriptions) {
            if (this.prescriptionForm.id) {
              if (obj.id === this.prescriptionForm.id) {
                this.print = this.prescriptionForm
              }
            }
          }
          this.prescriptionForm.date = new Date()
          this.fn_HIDE_PROGRESS()
        }
      )
    },
    removePrescription (id) {
      const self = this
      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: `Tem certeza que deseja apagar a receita?`,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose (v) {
          if (!v) {
            this.$store.dispatch('setModalConfirm')
          } else {
            this.fn_SHOW_PROGRESS()
            this.$http.delete(`prescription/${id}`, this.$store.getters.getAuthHeader).then(
              (res) => {
                self.prescriptionForm.id = null
                self.$emit('success', true)
                this.$store.dispatch('setModalConfirm')
                this.$store.dispatch('setModalAlert', {
                  title: 'Sucesso',
                  body: 'Receita removida com sucesso',
                  size: 'md',
                  active: true
                })
                setTimeout(() => {
                  this.$store.dispatch('setModalAlert', {
                    active: false
                  })
                }, 2000)
                self.fetchPrescriptions()
                self.fn_HIDE_PROGRESS()
              }
            )
          }
        },
        size: 'md',
        active: true
      })
    },
    getCopies (obj) {
      for (let prescriptionMedicament of obj.prescription_medicaments) {
        if (prescriptionMedicament.is_special_prescription || prescriptionMedicament.medicament.is_special_prescription) {
          return 1
        }
      }
      return 0
    },
    generatePrescription () {
      let note = ''
      for (let item of this.prescriptionForm.prescriptionMedicaments) {
        // prescription.push({id: item.id})
        if (item.id) {
          note = note + `<li>${item.name} - ${item.quantity} unidade${item.quantity > 1 ? 's' : ''}<br /><strong>Posologia:</strong> ${item.posology}`
          if (item.description.length > 0) {
            note = note + `<br /><strong>Observações</strong>: <em>${item.description}</em><br /><br />`
          }
          note = note + '</li>'
        }
      }
      return note
    },
    submit ({ showConfirmation = true, nextSection = null, nextTab = null } = {}) {
      const self = this
      let blank = false
      let hasMedicaments = false

      if (!this.prescriptionForm.valid) {
        return
      }

      for (let item of this.prescriptionForm.prescriptionMedicaments) {
        if (item.id) {
          hasMedicaments = true
        } else if (item.name) {
          blank = true
        }
      }

      if (!hasMedicaments) {
        return false
      }

      if (blank) {
        this.$store.dispatch('setModalConfirm', {
          title: 'Confirmação',
          body: `Você possui um medicamento escolhido, mas que não foi efetivamente adicionado à receita atual. Deseja prosseguir assim mesmo?`,
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          size: 'md',
          active: true,
          beforeClose (v) {
            if (v) {
              self.save({ showConfirmation, nextSection, nextTab })
            }
            this.$store.dispatch('setModalConfirm')
          }
        })
      } else {
        this.save({ showConfirmation, nextSection, nextTab })
      }
    },

    save ({ showConfirmation = true, nextSection = null, nextTab = null }) {
      const prescriptionMedicaments = this.prescriptionForm.prescriptionMedicaments
        .filter(medicament => medicament.id)
        .map((medicament) => {
          return {
            note: medicament.note,
            medicament: medicament.id,
            quantity: medicament.quantity,
            posology: medicament.posology,
            isSpecialPrescription: medicament.isSpecialPrescription ? 1 : 0,
            medicamentPrescriptionQuantityUnity: medicament.measureUnity
          }
        })

      let groupedMedicaments = prescriptionMedicaments
        .filter(med => med.isSpecialPrescription === 1)

      groupedMedicaments.push(
        prescriptionMedicaments.filter(med => med.isSpecialPrescription === 0)
      )

      groupedMedicaments = groupedMedicaments
        .filter((item) => {
          const isEmptyArray = Array.isArray(item) && item.length === 0
          const isObject = !Array.isArray(item)
          return isObject || !isEmptyArray
        })

      const promises = groupedMedicaments.map((group) => {
        const data = {
          agenda: this.prescriptionForm.agenda,
          prescriptionMedicaments: Array.isArray(group) ? group : [group]
        }

        return this.$http
          .post(
            '/prescription',
            { prescription: data },
            this.$store.getters.getAuthHeader
          )
      })

      this.sending = true
      this.fn_SHOW_PROGRESS()
      EventBus.$emit('appointment-start-saving')
      Promise.all(promises)
        .then((res) => {
          if (showConfirmation) {
            let msg = groupedMedicaments.length > 1
              ? `Receita gerada com sucesso. Os medicamentos de uso controlado
                foram prescritos em receitas separadas.`
              : 'Receita gerada com sucesso.'

            if (
              !this.isActiveAppointment &&
              groupedMedicaments.length > 1 &&
              this.patient.email
            ) {
              msg = `Sua receita foi gerada com sucesso, e os medicamentos de uso
                controlado foram prescritos em receitas separadas.
                Esses documentos serão enviados para o e-mail do paciente
                (<b>${this.patient.email}<b>), e, caso você tenha certificado de
                assinatura digital, levará alguns minutos para que o documento
                seja assinado digitalmente.`
            }

            if (
              !this.isActiveAppointment &&
              groupedMedicaments.length > 1 &&
              !this.patient.email
            ) {
              msg = `Sua receita foi gerada com sucesso, e os medicamentos de uso
                controlado foram prescritos em receitas separadas. Caso você tenha
                certificado de assinatura digital, levará alguns minutos para que o
                documento seja assinado digitalmente.`
            }

            if (
              !this.isActiveAppointment &&
              groupedMedicaments.length === 1 &&
              !this.patient.email
            ) {
              msg = `Sua receita foi gerada com sucesso. Caso você tenha
                certificado de assinatura digital, levará alguns minutos
                para que o documento seja assinado digitalmente.`
            }

            if (
              !this.isActiveAppointment &&
              groupedMedicaments.length === 1 &&
              this.patient.email
            ) {
              msg = `Sua receita foi gerada com sucesso e será enviada para o
                e-mail do paciente (<b>${this.patient.email}</b>). Caso você tenha
                certificado de assinatura digital, levará alguns minutos
                para que o documento seja assinado digitalmente.`
            }

            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: msg.replace(/(\r\n|\r|\n)/gm, ''),
              size: 'md',
              active: true
            })
          }

          if (nextSection) EventBus.$emit('consultation-change-section', nextSection)
          if (nextTab) EventBus.$emit('consultation-change-tab', nextTab)
        })
        .catch(err => this.handleError(err))
        .finally(() => {
          this.sending = false
          this.fn_HIDE_PROGRESS()

          this.medIndex = 0
          this.prescriptionForm = {
            valid: false,
            id: null,
            agenda: this.appointment.id,
            name: '',
            prescriptionMedicaments: [
              {
                index: this.medIndex,
                id: null,
                name: '',
                posology: '',
                note: '',
                isSpecialPrescription: false,
                edit: true,
                quantity: 1
              }
            ]
          }
          this.selectedModel = null
          this.prescriptionForm.note = ''
          this.resetAutocompletes += 1
          this.fetchPrescriptions()

          EventBus.$emit('appointment-stop-saving')
          EventBus.$emit('reload-file-history')
        })
    },

    toggleCaret (caretId) {
      const caret = document.querySelector(caretId)
      caret.classList.toggle('allergies-alert__caret--down')
      caret.classList.toggle('allergies-alert__caret--right')
      this.allergies.collapsed = !this.allergies.collapsed
    },

    handleError (err) {
      const msg = (typeof err !== 'object')
        ? err
        : ('errors' in err)
          ? this.findErrorMessage(err.errors)
          : 'Ocorreu um erro.'

      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: Array.isArray(msg) ? msg[0] : msg,
        size: 'md',
        active: true
      })
    },

    findErrorMessage (object) {
      let errorMessage = null

      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }

      if (Array.isArray(object)) {
        object.forEach((element) => {
          if (typeof element === 'object') {
            recursiveSearch(element)
          } else {
            errorMessage = element
          }
        })
      } else {
        recursiveSearch(object)
      }

      return errorMessage
    },

    openPrescription (prescription) {
      if (('signed_file' in prescription) && prescription['signed_file']) {
        const url = `${process.env.ROOT_API}/s3/file/prescription/${prescription['id']}/signed_file`
        this.$http
          .get(
            url,
            {
              headers: this.$store.getters.getAuthHeader.headers,
              responseType: 'blob'
            }
          )
          .then(res => this.generatePDFFile(res.data))
          .then(objURL => this.embedFile(objURL))
          .then((embed) => {
            if (embed) {
              this.currentDocument = 'Receita médica'
              this.modalType = 'document'
            }
          })
          .catch(err => console.trace(err))
      } else {
        this.modalActive = prescription
      }
    },

    generatePDFFile (rawData) {
      const blob = new Blob([rawData], { type: 'application/pdf' })
      return URL.createObjectURL(blob)
    },

    embedFile (file = null) {
      if (file) {
        const wrapper = document.querySelector('#pdf__container')
        const embed = document.createElement('embed')
        embed.classList.add('pdf-file')
        embed.style.height = '70vh'
        embed.style.width = '100%'
        embed.setAttribute('src', file)
        wrapper.appendChild(embed)

        return true
      }

      return false
    },

    removeEmbed () {
      const wrapper = document.querySelector('#pdf__container')
      const embed = wrapper.querySelectorAll('embed')
      for (let el of embed) {
        el.remove()
      }
      this.modalType = null
      this.currentDocument = null
    },

    hasUnsavedData () {
      return this.prescriptionForm.prescriptionMedicaments.some((item) => !item.edit)
    }
  }
}
</script>
